// extracted by mini-css-extract-plugin
export default {"status":"Status_status__kPwXR","statusCircle":"Status_statusCircle__nZcQZ","ping":"Status_ping__3OT7y","statusText":"Status_statusText__ypHIR"};